// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2hN9R","location":"Header_location__1xkHp"};